import React from 'react';
import styled from 'styled-components/macro';

const TablaVotosPartidos_FilaCandidatoCargo = props => {
  return (
    <td className="cargos">
      <ContenedorVotoProferente>
        {/* {props.data.carg === "1" && (<VotoPreferente></VotoPreferente>)} */}
        {props.data.carg==="1"?
          (props.data.empate==="1"?
            <VotoEmpate>S/A**</VotoEmpate>
          :(<VotoPreferente></VotoPreferente>))
        :(<></>)}
      </ContenedorVotoProferente>
    </td>
  );
};

const ContenedorVotoProferente = styled.div`
display: flex;
justify-content: flex-end;
`;

const VotoPreferente = styled.span`
background: black;
height: 10px;
width: 10px;
display: block;
border-radius: 50%;
`;

const VotoEmpate = styled.span`
font-size: 13px;
font-weight: 500;
text-align: right;
`;

export default TablaVotosPartidos_FilaCandidatoCargo;
